import PlusIcon from 'mdi-react/PlusIcon'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { compose } from 'redux'

import Page from '@/components/content/Page'
import { FormattedNumberWithCurrency } from '@/components/FormattedNumberWithCurrency'
import { useText } from '@/components/i18n/hooks'
import { Translation } from '@/components/i18n/Translation'
import { LocalDate } from '@/components/LocalDate'
import ButtonLink from '@/components/util/ButtonLink'
import { getCustomerFromId } from '@/ducks/customersReducer'
import { getOpenQuotes } from '@/ducks/shopQuotesReducer'
import withCustomersLoaded from '@/hocs/withCustomersLoaded'
import withShopQuotesLoaded from '@/hocs/withShopQuotesLoaded'
import useRenderLimit from '@/hooks/render-limit-hook'
import { useIsBechtle } from '@/hooks/user'
import { getCreditCheckTextId } from '@/util/credit-check'
import { appRoutes } from '@/util/misc'

import CreditCheckStatusIcon from './credit-check/CreditCheckStatusIcon'

import './shop-quote-list-page.scss'

const ShopQuoteListPage = () => {
  const quotes = useSelector(getOpenQuotes)
  const isBechtle = useIsBechtle()

  const { visibleList, ListLoaderComponent } = useRenderLimit(quotes)

  return (
    <Page className="shop-quote-list-page">
      <h1>
        <Translation id="Quotes" />
      </h1>

      <ButtonLink to={appRoutes.shopQuote.replace(':order_id', 'new')}>
        <PlusIcon />
        <Translation id="New quote" />
      </ButtonLink>

      {visibleList.length > 0 && (
        <table>
          <thead>
            <tr>
              <th>
                <Translation id="Created" />
              </th>
              <th>
                <Translation id="Quote Name" />
              </th>
              <th>
                <Translation id="Ref" />
              </th>
              <th>
                <Translation id="Customer" />
              </th>
              <th className="number">
                <Translation id="Cost" />
              </th>
              {isBechtle && (
                <th>
                  <Translation id="Status" />
                </th>
              )}
            </tr>
          </thead>
          <tbody>
            {/* @ts-ignore */}
            {visibleList.map(order => (
              <Order key={order.id} {...order} />
            ))}
          </tbody>
        </table>
      )}

      <ListLoaderComponent />
    </Page>
  )
}

const Order = ({ id, order_value, order_name, customer_id, hpe_cc_status, created_date }: any) => {
  const customer = useSelector(state => getCustomerFromId(state, customer_id))
  const isBechtle = useIsBechtle()
  const appRoute = isBechtle ? appRoutes.creditCheckQuote : appRoutes.shopQuote
  const ccTitle = useText(getCreditCheckTextId(hpe_cc_status))

  return (
    <tr>
      <td>
        <LocalDate date={created_date} />
      </td>

      <td>
        <Link to={appRoute.replace(':order_id', id)}>
          {order_name || <Translation id="New quote" />}
        </Link>
      </td>

      <td>{id}</td>

      <td>{customer?.name}</td>

      <td className="number">
        <FormattedNumberWithCurrency amount={order_value} />
      </td>

      {isBechtle && (
        <td className="number" title={ccTitle}>
          <CreditCheckStatusIcon status={hpe_cc_status} />
        </td>
      )}
    </tr>
  )
}

export default compose(withCustomersLoaded, withShopQuotesLoaded)(ShopQuoteListPage)
